import { Detect } from "../internal/Detect"

/** `OffscreenCanvas`, or `undefined` where the environment has none (absent on Safari < 16.4). */
export const GetOffscreenCanvas = (): typeof OffscreenCanvas | undefined =>
  Detect("OffscreenCanvas")
